import { FormManager } from '@bark/bark-core/src/components/legacy-scripts/form-manager';
import BuyerApi from './../helpers/buyer-api';
import { _t } from '@bark/bark-core';
import { trackEmailPreferences } from '@bark/bark-core';

const SettingsRow = () => {
	const { Handlebars } = window;

	const settingsRowTemplate = Handlebars.compile(
		document.getElementById('settings-row-template').innerHTML,
	);

	const createHtml = (data) => {
		return settingsRowTemplate(data);
	};

	return {
		createHtml,
	};
};

export default function () {
	const buyerApi = BuyerApi();

	const {
		bugsnagClient,
		Bark: { api },
	} = window;

	const formManager = FormManager();
	const formManagerName = 'notification-settings-page-form';

	const settingsRow = SettingsRow();

	const state = {
		buyer: null,
		changedData: {},
	};

	const settingsLabelMap = {
		mail_is_notify_emails: _t(
			'buyer_notification-settings:settings-option-labels.request-changed',
		),
		mail_is_reminder_emails: _t(
			'buyer_notification-settings:settings-option-labels.reply-reminders',
		),
		mail_is_promo_emails: _t(
			'buyer_notification-settings:settings-option-labels.promotion-emails',
		),
	};

	const getSelf = () => {
		return buyerApi.getSelfPromise((res) => {
			state.buyer = res.data;
		});
	};

	const saveForm = (defer) => {
		let data = {};
		$('input[type=checkbox]').each(function () {
			data[$(this).attr('id')] = this.checked ? 1 : 0;
		});
		state.buyer.push_settings.forEach((setting) => {
			data[setting.key] = setting.value ? 1 : 0;
		});

		api(
			'/buyer/notifications',
			data,
			(res) => {
				if (res.status) {
					trackEmailPreferences(state.changedData, 'buyer', true);
					formManager.dirtyStateChanged();
					state.changedData = {};
					defer.resolve();
					formManager.dirty(formManagerName, false);
				}
			},
			(error) => {
				defer.reject();
				bugsnagClient.notify(new Error('Failed to save buyer notifications'), {
					metaData: error,
				});
				trackEmailPreferences(state.changedData, 'buyer', false);
			},
			'POST',
		);
	};

	const cancelForm = () => {
		formManager.dirty(formManagerName, false);
	};

	const buildSettings = () => {
		let emailSettingsForm = $('#email-settings-form');

		state.buyer.mail_settings.forEach((setting) => {
			setting.label = settingsLabelMap[setting.key];
			emailSettingsForm.append(settingsRow.createHtml(setting));
		});
	};

	const registerListners = () => {
		$('input[type=checkbox]').change(function () {
			const id = $(this).attr('id');
			if (state.changedData?.hasOwnProperty(id)) {
				delete state.changedData[id];
			} else {
				state.changedData[id] = Number($(this).prop('checked'));
			}
			formManager.dirty(formManagerName, true);
		});
	};

	const registerFormManager = () => {
		formManager.register(
			formManagerName,
			(defer) => {
				return saveForm(defer);
			},
			() => {
				return cancelForm();
			},
		);
	};

	const removeWaiting = () => {
		$('.buyer-email-notifications').removeClass('waiting');
	};

	const initPage = () => {
		registerFormManager();
		getSelf().then(() => {
			removeWaiting();
			buildSettings();
			registerListners();
		});
	};

	initPage();
}
